module.exports = __webpack_public_path__ + "img/couples_01_V.3e39305f.webp";